var map = {
	"./How-to-Choose-the-Right-Salon-for-Your-Beauty-Needs.png": 608,
	"./best-colouring-options-for-grey-hair.png": 795,
	"./celebrity cuts (14).png": 536,
	"./celebrity cuts (15).png": 895,
	"./celebrity cuts (16).png": 590,
	"./celebrity cuts menu card .pdf (2).png": 296,
	"./cut1.mp4": 204,
	"./cut2.mp4": 176,
	"./cut3.mp4": 734,
	"./cut4.mp4": 533,
	"./cut5.mp4": 40,
	"./cut6.mp4": 919,
	"./cut7.mp4": 434,
	"./cut8.mp4": 521,
	"./gallery/WhatsApp Image 2025-10-21 at 14.05.06_9d19297c.jpg": 309,
	"./gallery/g1.webp": 97,
	"./gallery/g2.webp": 756,
	"./gallery/g3.webp": 615,
	"./gallery/g4.webp": 850,
	"./gallery/g5.webp": 949,
	"./gallery/g6.webp": 552,
	"./gallery/g7.webp": 371,
	"./img1.jpg": 574,
	"./img2.jpg": 345,
	"./img3.avif": 356,
	"./logo.png": 153,
	"./salon-bg.mp4": 604,
	"./title.webp": 704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;